<template>
    <div class="reo-share-auth-container">
        <div class="share-table">
            <div class="title">{{ $t('share.authority.title') }}</div>
            <div class="cell-group">
                <cell v-for="(item, idx) in auths" :key="('cell-manage-' + idx)" :title="item.title" :inlineDesc="item.inlineDesc" :disabled="item.disabled" @click.native="authsItemClick(item, idx)">
                    <span slot="foot-icon" class="icon icon-right" :class="item.iconStyle"></span>
                </cell>
            </div>
        </div>
        <div class="share-btn" v-if="auths.length">
            <p v-if="!loading" @click="share">{{ $t('share.authority.shareBtn') }}</p>
            <p v-else>
                <infiniteLoading spinner="spiral" class="loading"></infiniteLoading>
            </p>
        </div>
        <pop-up
            v-if="showFailPopUp"
            textAlign='left'
            :title="$t('share.popUp.shareTip')"
            :description="$t('share.popUp.shareFail')">
        </pop-up>
    </div>
</template>

<script>
import cell from '@/components/cell';
import InfiniteLoading from 'vue-infinite-loading';
import { getDeviceInfo, createShareInvation } from '@/api/share';
import { requestToApp } from '@/api/app';

export default {
    components: {
        cell,
        InfiniteLoading
    },
    async created () {

        // 根据设备 uid 获取设备包含的所有权限
        this.uid = this.$route.params.uid;
        await this.getDeviceAuth();
        requestToApp( 'modifyPageTitle', {title: this.$t( 'share.pageTitle.createShared' )});

    },
    methods: {
        async getDeviceAuth () {

            // todo 判断视频预览和云存储
            let data = await getDeviceInfo( this.uid );
            this.auths = data.channels[0].privileges && data.channels[0].privileges.map( item => {

                let auth = {
                    name: item.name,
                    title: item.title,
                    order: item.order,
                    disabled: !item.shared,
                    isActive: false
                };
                if ( item.name === 'preview' ) { // 默认选中，视频预览

                    auth.isActive = true;
                    auth.isDefault = true;
                    auth.iconStyle = 'icon-default';

                } else if ( !item.shared ) { // 不可分享

                    auth.iconStyle = 'icon-disabled';

                } else {

                    auth.iconStyle = 'icon-disabled';

                }
                if ( item.maxShare > 0 ) {

                    auth.inlineDesc = this.$t( 'share.authority.maxShare', {maxShare: item.maxShare});

                }

                return auth;

            });
            this.auths.sort(( a, b ) => {

                return a.order - b.order;

            });

        },
        async share () {

            if ( !this.loading ) {

                this.loading = true;
                let channels = [];
                let channel = {};
                channel.channel = 0;
                channel.privileges = this.auths.filter( item => {

                    return item.isActive && item.name;

                });
                channel.privileges = channel.privileges.map( item => {

                    return item.name;

                });
                channels.push( channel );
                await createShareInvation( this.uid, channels ).then( data => {

                    console.log( 'shareAuth return', data );
                    let date = new Date().getTime();
                    let reg = new RegExp( '(expiredAt=[^&]*)', 'g' );
                    let expiredAt = data.url && data.url.match( reg );
                    expiredAt = expiredAt[0] ? expiredAt[0].split( '=' )[1] : '';
                    let expired = expiredAt ? parseInt( expiredAt ) - date : 0;

                    requestToApp(
                        'jumpToGenerateCode',
                        {
                            url: `/share/generateCode/?maxNum=${data.maxTimes}&expired=${parseInt( expired / 1000 / 60 )}&url=${data.url}`
                        }
                    );

                }, () => {

                    // 分享失败
                    this.loading = false;
                    this.openFailPopUp();
                    setTimeout(() => {

                        this.closeFailPopUp();

                    }, 3000 );

                });

            }

        },
        authsItemClick ( item, idx ) {

            // 默认选中，不可修改
            if ( !!item.isDefault || !!item.disabled ) {

                return false;

            } else {

                item.isActive = !item.isActive;
                item.iconStyle = item.isActive ? 'icon-active' : 'icon-disabled';

            }
            this.auths.splice( idx, 1, item );
            let auth = this.auths;
            this.auths = [];
            this.auths = auth;

        },
        openFailPopUp () {

            this.showFailPopUp = true;

        },
        closeFailPopUp () {

            this.showFailPopUp = false;

        }
    },
    data () {

        return {
            uid: '',
            loading: false,
            auths: [],
            showFailPopUp: false
        };

    }
};
</script>

<style lang="less">
.reo-share-auth-container {
    background: #f7f8f9;
    padding: 0;
    .share-table {
        .title {
            color: #777777;
            font-size: 0.22rem;
            line-height: 0.4rem;
            padding: 0.4rem 0.3rem 0.1rem;
            background: #f7f8f9;
            margin: 0;
        }
        .cell-group {
            .reo-cell-box:nth-child(1) {
                .reo-cell::before{
                    display: none;
                }
            }
            .reo-cell {
                .reo-cell_ficon {
                    color: #e1e1e1;
                    .icon {
                        font-size: .6rem;
                    }
                    .icon-default {
                        opacity: 0.4;
                        background: linear-gradient(127deg, #1E70F1 0%, #1E8EEC 31%, #1DD5DF 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                    .icon-active {
                        opacity: 1;
                        background: linear-gradient(127deg, #1E70F1 0%, #1E8EEC 31%, #1DD5DF 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                    .icon-disabled {
                        opacity: 1;
                        color: #e1e1e1;
                        background: unset;
                        -webkit-background-clip: unset;
                        -webkit-text-fill-color: unset;
                    }
                }
            }

        }
    }
    .share-btn {
        position: absolute;
        bottom: 1rem;
        width: 100%;
        z-index: 10;
        p {
            margin: 0 0.8rem;
            text-align: center;
            font-size: 0.34rem;
        height: 0.88rem;
        line-height: 0.88rem;
            color: #fff;
            background: linear-gradient(167deg, #1E7FEF 0%, #1DC1E1 100%);
            box-shadow: 0 0.03rem 0.13rem rgba(0, 157, 225, 0.4);
            border-radius: 0.42rem;
        }
        .infinite-loading-container div {
            font-size: 0;
        }
        .loading-spiral {
            margin: 0.2rem auto !important;
            width: 0.4rem !important;
            height: 0.4rem !important;
            font-size: 0.4rem !important;
            line-height: unset !important;
            border-color: #fff !important;
            border-right-color: transparent !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/share/shareAuth.vue